import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { SortableContainer } from 'react-sortable-hoc';
import i18n from 'react-intl-universal';
import styles from './NotesWrapper.scss';

import { NOTES_NOT_FOUND } from '../../constants/variables';
import { Notebooks, Notes } from '../../constants/actionTypes';
import logEvents from '../../constants/logEvents';

import Icon from '../Icon/Icon';
import NoteList from '../NoteList/NoteList';
import withLoading from '../../HOC/withLoading';

import { setNoteData } from '../../actions/GlobalAction';
import { newNote } from '../../actions/NotesAction';

import { getState } from '../../reducers/Notebooks/NotebooksReducer';
import { getState as getNotes } from '../../reducers/Notes/NotesReducer';
import { getState as getUser } from '../../reducers/User/UserReducer';

import { getNormalPageUrl } from '../../utils/urlHelper.js';
import { martinDispatch } from '../../utils/util.js';
import formatDate from '../../utils/formatDate.js';
import logger from '../../utils/logger';

@SortableContainer
@withRouter
@connect(
  state => ({
    notebooks: getState(state),
    notes: getNotes(state),
    notesStatus: getNotes(state).get('status'),
    user: getUser(state),
  }),
  dispatch => ({
    setNoteData: data => dispatch(setNoteData(data)),
    newNote: (nbId, title, atBottom, hasTop) =>
      martinDispatch(dispatch, newNote(nbId, title, atBottom, hasTop)),
  }),
)
@withLoading((props) => {
  const { notebooks, notesStatus, match } = props;
  const { params: { nbId } } = match;
  const notes = notebooks.getIn(['entities', nbId, 'notes'], NOTES_NOT_FOUND);
  // 如果已经获取到notebooks，且其长度为0，则移除loading
  const seq = notebooks.get('seq');
  const status = notebooks.get('status');
  // eslint-disable-next-line max-len
  if (seq && seq.size === 0 && status !== Notebooks.NOTEBOOKS_INIT && status !== Notebooks.GET_NOTEBOOKS) {
    return false;
  }
  if (notesStatus === Notes.GET_NOTES_FAIL) {
    return false;
  }
  return notes === NOTES_NOT_FOUND;
})({ tip: 'global.note-loading', wrapperClassName: styles['sort-wrapper'] })
export default class NotesWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCreatingNote: false,
    };
  }

  createNewNote = (atBottom = false) => {
    const { match, history, user, notebooks, notes } = this.props;
    const { params: { nbId } } = match;
    const { isCreatingNote } = this.state;
    if (isCreatingNote) {
      return;
    }
    this.setState({
      isCreatingNote: true,
    });
    const firstNote = notebooks.getIn(['entities', nbId, 'notes', 0]);
    const hasTop = firstNote ? notes.getIn(['entities', firstNote.toString(), 'is_top']) : false;
    this.props.newNote(nbId, formatDate(new Date(), 'yyyy-MM-dd'), atBottom, hasTop).then((res) => {
      // 创建文章成功后再打log
      logger.addLog({
        atBottom,
        event: logEvents.CREATE_NEW_NOTE,
        user_id: user.getIn(['user', 'id']),
        new_note_id: res.id,
      });
      // 跳转至新建文章, 通过isInitNote标识首次创建文章
      this.props.setNoteData({ isInit: true });
      if (+res.id !== +this.props.match.params.noteId) {
        history.push(getNormalPageUrl(nbId, res.id));
      }
      this.setState({
        isCreatingNote: false,
      });
    }).catch((error) => {
      this.setState({
        isCreatingNote: false,
      });
    });
  };

  onCreateNoteBtnClick = () => {
    this.createNewNote();
  };

  createNewNoteAtBottom = () => {
    this.createNewNote(true);
  };

  render() {
    const { isCreatingNote } = this.state;
    return (
      <div>
        <div className={styles['new-note-top']} onClick={this.onCreateNoteBtnClick}>
          <Icon name={'plus-circle'}/>
          <span> {i18n.get(isCreatingNote ? 'notes.new-note-ing' : 'notes.new-note')}</span>
        </div>
        <NoteList/>
        <div className={styles['new-note-bottom']} onClick={this.createNewNoteAtBottom}>
          <Icon name={'plus'}/>
          <span> {i18n.get(isCreatingNote ? 'notes.new-note-ing' : 'notes.new-note-bottom')}</span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NotesWrapper/NotesWrapper.js